module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', {
    staticClass: "fa fa-broadcast-tower"
  }, [_vm._v(" ")]), _c('org-badge'), _vm._v(" Dashboard"), (!_vm.isTowerCo() && _vm.org().shortName) ? _c('small', {
    staticClass: "text-info pull-right hidden-sm-and-down"
  }, [_vm._v(_vm._s(_vm.org().name))]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-tower-cell"
  }), _vm._v(" Tower Suppliers Report")]), _vm._v(" "), _c('tower-suppliers-report')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v(" Structures Report")]), _vm._v(" "), _c('structure-report', {
    attrs: {
      "supplier": ""
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85573cc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TowerSupplierView.vue
// module id = 1669
// module chunks = 0